namespace appn.views.platform.clients {

    class InitArgs {
        columnCount: number = 0;
        columnWidths: number = 0;
        platformCreateClient: string = emptyString;
    }

    let _initArgs: InitArgs;

    let _dataTable: any = null;

    export function init(args: InitArgs): void {
        _initArgs = args;
        createDataTable();
    }

    function createDataTable() {
        
        _dataTable = appn.dataTable.create('.dataTable', {
            sAjaxSource: 'ClientsDataTable',
            fnServerData: function(data: any) {
                data.push(appn.dataTable.getStateOrDefault('sCustom_0', $('#sCustom_0').prop('checked'))); // Show Archived filter
            },
            autoWidth: false,
            aoColumns: getDtColConfiguration(),
            fnInitComplete: function() {
                // Add in inactive checkbox in filter row

                $('#addnew').click(function(event) {
                    event.preventDefault();
                    appn.location.navTo(_initArgs.platformCreateClient);
                });

                // Add in inactive checkbox in filter row
                $('.dataTables_filter').prepend(appn.elementBuilder.buildCheckbox(appn.strings.showRetired, 'saveMeState', 'sCustom_0')).append($('.dt-action-button'));

                appn.dataTable.addSearchPlaceholder(T('Filter results where the Clients <b>Name or Status</b> contains a keyword typed in here.'));

                $('.dataTables_controls_start').append($('.dt-action-title'));

                appn.saveMeState.init(function() {
                    _dataTable.fnDraw(false);
                },
                function() {
                    _dataTable.fnDraw(false);
                }, '.dataTables_filter');
            },
            fnDrawCallback: function() {
                $('.viewUserAudit').off().on('click', function (this: HTMLElement, event: Event) {
                    event.preventDefault();
                    const auditUrl = $(this).attr('href') as string;
                    appn.iframe.openModal({
                        url: auditUrl,
                        size: 'modal-xl'
                    });
                });
            }
        });
    }

    function getDtColConfiguration(): Array<IDTColumns> {
        const aoColumns: Array<IDTColumns> = [];

        aoColumns.push({ bSortable: true, sWidth: '35%' } as IDTColumns);

        for (let i = 1; i < _initArgs.columnCount; i++)
            aoColumns.push({ bSortable: true, sWidth: `${_initArgs.columnWidths}%` } as IDTColumns);

        aoColumns.push({ bSortable: true, sWidth: '15%' } as IDTColumns,
            { bSortable: true, sWidth: '15%' } as IDTColumns);

        return aoColumns;
    }
}
